import { render, staticRenderFns } from "./shopping_cart.vue?vue&type=template&id=279b8140&scoped=true"
import script from "./shopping_cart.vue?vue&type=script&lang=js"
export * from "./shopping_cart.vue?vue&type=script&lang=js"
import style0 from "./shopping_cart.vue?vue&type=style&index=0&id=279b8140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b8140",
  null
  
)

export default component.exports